export default "__VITE_ASSET__31f57235__"